/* FootJersey geo-shipping: preenche a barra "FREE SHIPPING [TO PAÍS] VIA [logo transportadora]". */
(function () {
  var NAMES = { gb: 'Royal Mail', us: 'FedEx', nl: 'PostNL', se: 'PostNord', ch: 'Swiss Post', ca: 'Canada Post', fr: 'Colissimo' };
  function flagEmoji(code) {
    return code.toUpperCase().replace(/[A-Z]/g, function (c) {
      return String.fromCodePoint(127462 + c.charCodeAt(0) - 65);
    });
  }
  function run() {
    var bars = document.querySelectorAll('[data-fj-geo-shipping]');
    if (!bars.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root.replace(/\/+$/, '') + '/browsing_context_suggestions.json?country=1', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var dv = d && d.detected_values;
        var code = dv && dv.country && dv.country.handle;
        var name = (dv && dv.country_name) || '';
        if (!code || !/^[A-Za-z]{2}$/.test(code)) return;
        var flag = flagEmoji(code);
        var lc = code.toLowerCase();
        bars.forEach(function (bar) {
          var f = bar.querySelector('[data-fj-geo-flag]');
          var cn = bar.querySelector('[data-fj-geo-country]');
          var cr = bar.querySelector('[data-fj-geo-carrier]');
          if (f) f.textContent = flag;
          if (cn) cn.textContent = 'TO ' + name.toUpperCase();
          if (cr) {
            var url = cr.getAttribute('data-logo-' + lc);
            if (url) { cr.src = url; cr.alt = NAMES[lc] || 'DHL'; }
          }
        });
      })
      .catch(function () { /* mantém DHL */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
